<div class="search-block">
  <div class="container search-desktop">
    <div class="row">
      <div class="col-md-6 col-7 col-lg-6 home-nav breadcrumb-header">
        <ol class="breadcrumb loginMenu">
                <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home /&nbsp;</a>
              <a class="bd-crumb-active">{{i18n['shp.result.search']}}</a>
        </ol>
    </div>
      <!-- <div class="col-md-4 searchresult-header">
        <span>{{i18n['shp.result.search']}}</span>
      </div> -->
      <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
        <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword" [ngModel]="searchKeyword"
          (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
          [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" (keydown.enter)="onKeyEnterSearch($event,selectedValue)" 
          (inputCleared)="searchCleared()" aria-label="Type here to Search an Article" placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
        </ng-autocomplete>
  
        <ng-template #itemTemplate let-item>
          <a [innerHTML]="item.name"></a>
        </ng-template>
  
        <ng-template #notFoundTemplate let-notFound>
           No Suggestion...
            <!-- <div [innerHTML]="notFound"></div> -->
        </ng-template>
  
        <span class="input-group-append" (click)="onSearchBtnClicked(selectedValue)">
          <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="search-mobile">
  <div class="row">
    <div class="col-md-4 home-nav">
      <ol class="breadcrumb loginMenu">
              <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home /&nbsp;</a>
            <a class="bd-crumb-active">{{i18n['shp.result.search']}}</a>
      </ol>
  </div>
    <div class="input-group col-md-5 searchContainer" style="width:90% !important;">
      <i class="fa fa-search search-bar"></i>
      <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword" [ngModel]="searchKeyword"
        (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" (keydown.enter)="onKeyEnterSearch($event,selectedValue)"
        (inputCleared)="searchCleared()" aria-label="Type here to Search an Article" placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
            No Suggestion...
      </ng-template>
      <span class="input-group-append" (click)="onSearchBtnClicked(selectedValue)">
        <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
          <i class="fa fa-search"></i>
        </button>
      </span>
    </div>
  </div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
<div *ngIf="searchResultsFound; then resultsFoundBlock else errorBlock">
</div>
<ng-template #resultsFoundBlock>
  <div class="landingBgColor article">
    <div class="container p-20 article-bgrnd">
      <h4 class="aricles-header">{{count}} articles found for "{{text}}"</h4>
      <ul style="list-style-type: none;" *ngFor="let item of entireCollection | paginate: config">
        <li >
          <a [routerLink]="['../viewarticles']" [queryParams]="{articleId: item.id,currentPage: this.config.currentPage,selectedValue: this.selectedValue}">
            <h4 class="article-topic" [innerHTML]=item.name ></h4>
          </a>
          <p [innerHTML]=item.frag_data ></p>
        </li>
      </ul>
  
      <ul class="pagination" *ngIf="collection.length>0">
        <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
      </ul>
    </div>
  </div>
</ng-template>
<ng-template #errorBlock>
  <h3 *ngIf="!isLoading"
    style="text-align: center; padding: 15px;">Something went wrong. Please try again.</h3>
</ng-template>

<!-- p = $event -->